import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { F_STR } from 'assets/FormatNumbers'
import { messageColor } from 'types/ReferTypes'
import { response } from 'utils/apiUtil'

// モーダル共通処理(PageReducerと大体同じ)

type ModalState = {
  open: boolean // モーダルを開いているかどうか
  loading: boolean // ローディング状態
  message: string // メッセージ
  messageColor: messageColor // メッセージの色
}

const initialState: ModalState = {
  open: false, // モーダルを開いているかどうか
  loading: false, // ローディング状態
  message: F_STR, // メッセージ
  messageColor: 'red', // メッセージの色
}
export const ModalSlice = createSlice({
  name: 'ModalUser',
  initialState: initialState,
  reducers: {
    // モーダルを開く //===========================//
    open: (state) => {
      for (const key in state) {
        const tempKey: keyof ModalState = key as keyof ModalState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
      state.open = true
    },
    // モーダルを閉じる //===========================//
    close: (state) => {
      for (const key in state) {
        const tempKey: keyof ModalState = key as keyof ModalState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
    },
    // メッセージ変更(青字) //===========================//
    changeMessageSuccess: (state, action: PayloadAction<string>) => {
      state.message = action.payload
      state.messageColor = 'blue'
    },
    // メッセージ変更(赤字) //===========================//
    changeMessageError: (state, action: PayloadAction<string>) => {
      state.message = action.payload
      state.messageColor = 'red'
    },
    // メッセージ変更(直接設定) //===========================//
    changeMessageDirect: (state, action: PayloadAction<{ message: string; color: messageColor }>) => {
      state.message = action.payload.message
      state.messageColor = action.payload.color
    },
    // メッセージ変更(APIレスポンスから設定) //===========================//
    changeMessage: (state, action: PayloadAction<response<any>>) => {
      const payload = action.payload
      state.message = payload.message
      state.messageColor = payload.error || payload.alert ? 'red' : 'blue'
    },
    // メッセージ初期化 //===========================//
    deleteMessage: (state) => {
      state.message = initialState.message
    },
    // ローディング開始 //===========================//
    startLoading: (state, action: PayloadAction<string>) => {
      state.loading = true
      state.messageColor = 'green'
      state.message = action.payload
    },
    // ローディング終了 //===========================//
    endLoading: (state) => {
      state.loading = false
    },
    // ローディング処理 //===========================//
    changeLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    // 条件初期化 //===========================//
    format: (state) => {
      for (const key in state) {
        const tempKey: keyof ModalState = key as keyof ModalState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
    },
  },
})

// actionCreator 書き忘れないこと！
export const {
  open, // モーダルを開く
  close, // モーダルを閉じる
  changeMessageSuccess, // メッセージ変更(青字)
  changeMessageError, // メッセージ変更(赤字)
  changeMessageDirect, // メッセージ変更(直接設定)
  changeMessage, // メッセージ変更
  deleteMessage, // メッセージを初期化する処理
  startLoading, // ローディング開始
  endLoading, // ローディング終了
  changeLoading, // ローディング処理
  format, // 条件初期化
} = ModalSlice.actions
export default ModalSlice.reducer
